export default "__VITE_ASSET__DmdDvpWh__"